import { handleErrors } from '../utils/_handleErrors';
const customSelect = require('../utils/_customSelect');

class oInitReco extends HTMLDivElement {
    constructor() {
        super();
        this.loadAtInit = 'loadAtInit' in this.dataset;
    }

    connectedCallback() {
        this.recoLoaded = false;
        if (this.loadAtInit) {
            this.initRecommendation();
        } else {
            var intersectionObserver = new IntersectionObserver(entries => {
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }
                if (!this.recoLoaded) {
                    this.recoLoaded = true;
                    this.initRecommendation();
                }
            });
            intersectionObserver.observe(this);
        }
    }

    initRecommendation() {
        if (this.id && this.id.includes('cross-sell')) {
            this.loadRecommendation();
        }
    }

    loadRecommendation() {
        const url = this.dataset.url;

        if (url) {
            fetch(url, { 
                Method: 'GET' 
            })
                .then(handleErrors)
                .then((response) => response.text() )
                .then((htmlProductRecommendation) => {
                    this.innerHTML = htmlProductRecommendation;
                    var gtmEvents = this.querySelectorAll('[data-gtm-product-list-data]');
                    
                    for (var gtmEvent of gtmEvents) {
                        var dataObj = JSON.parse(gtmEvent.value);
                        var event = new CustomEvent('gtm:pushEvent', {
                            detail: {
                                data: dataObj,
                                pageType: true
                            }
                        });
                        document.dispatchEvent(event);
                    }
                    customSelect.initCustomSelect(this);
                });
        }
    }
}

customElements.define('o-init-reco', oInitReco, {
    extends: 'div'
});
